module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/vi/3-ad9492ab897c879a7e0a24146fba3d91.jpg";